import { createMuiTheme } from '@material-ui/core';
import { red } from '@material-ui/core/colors';

// eslint-disable-next-line import/prefer-default-export
export const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#03dac4',
        },
        secondary: {
            main: '#03dac4',
        },
        error: {
            main: red.A400,
        },
        background: {
            default: '#fff',
        },
    },
});
